export const CRM_SOURCE_OPTIONS = [
  'Facebook',
  'Instagram',
  'Google',
  'Indicação',
  'Fachada',
  'Site',
  'Orgânico',
  'Convênio',
  'Carteira de Pacientes',
  'Radio',
  'TV',
];

export const DEFAULT_CRM_SOURCE = CRM_SOURCE_OPTIONS[0];
